import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function RequireAdmin({ children }) {
    const HOME = "/dashboard";
    const { user } = useSelector((state) => state.auth);

    if (user && user.is_admin === true) {
        return children;
    }

    // reject by default.
    return <Navigate to={HOME} />;
}

export default RequireAdmin;
